import { render } from "./TableFooterWrapper.vue?vue&type=template&id=2958be62&scoped=true"
import script from "./TableFooterWrapper.vue?vue&type=script&lang=js"
export * from "./TableFooterWrapper.vue?vue&type=script&lang=js"

import "./TableFooterWrapper.vue?vue&type=style&index=0&id=2958be62&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2958be62"]])

export default __exports__